import useCan from '@/composables/useCan'
import { portalApi } from '@/util/apiClient'
import { queryClient } from '@/util/queryClient'
import { useQuery } from '@tanstack/vue-query'
import { computed, type ComputedRef } from 'vue'

const pollingMS = 60000

export const APPLIANCES_QUERY_KEY = ['galvanickAppliances', 'sidebarWarning']

/**
 * Whether the Deployment page is showing a warning: an appliance without a VRF,
 * counted only for callers the page would show it to.
 */
const useDeploymentWarning = (): ComputedRef<boolean> => {
  const canManageAppliances = useCan('manageAppliances')

  const { data: appliances } = useQuery(
    {
      queryKey: APPLIANCES_QUERY_KEY,
      queryFn: () => portalApi.galvanickAppliancesGet({ query: { limit: 100 } }),
      enabled: canManageAppliances,
      refetchInterval: pollingMS,
    },
    queryClient,
  )

  return computed(
    () =>
      canManageAppliances.value &&
      !!appliances.value?.results?.some((a) => !a.vrf_id),
  )
}

export default useDeploymentWarning
